module.exports = __webpack_public_path__ + "static/media/wolf.98d5021f.mp3";